import { Routes } from '@angular/router';
import { AppShellComponent } from './app-shell/app-shell.component';
import { AuthGuard } from './common/auth.guard';
import { LoadExpenseTrackerData } from './mini-apps/expense-app/resolver/expense-tracker-load-data.resolver';

export const routes: Routes = [
	{
		path: 'login',
		loadComponent: () =>
			import('./login/login.component').then((m) => m.LoginComponent),
	},
	{
		path: 'register',
		loadComponent: () =>
			import('./register/register.component').then((m) => m.RegisterComponent),
	},
	{
		path: 'wordle',
		loadComponent: () =>
			import('./mini-apps/wordle/wordle.component').then(
				(m) => m.WordleComponent,
			),
		canActivate: [AuthGuard],
	},
	{
		path: 'hangman',
		loadComponent: () =>
			import('./mini-apps/hangman/hangman.component').then(
				(m) => m.HangmanComponent,
			),
		canActivate: [AuthGuard],
	},
	{
		path: 'math-practice',
		loadComponent: () =>
			import('./mini-apps/math-practice/math-practice.component').then(
				(m) => m.MathPracticeComponent,
			),
		canActivate: [AuthGuard],
	},
	{
		path: 'word-search',
		loadComponent: () =>
			import('./mini-apps/word-search/word-search.component').then(
				(m) => m.WordSearchComponent,
			),
		canActivate: [AuthGuard],
	},
	{
		path: 'word-tadka',
		loadComponent: () =>
			import('./mini-apps/word-tadka/word-tadka.component').then(
				(m) => m.WordTadkaComponent,
			),
		canActivate: [AuthGuard],
	},
	{
		path: 'pour-genius',
		loadComponent: () =>
			import('./mini-apps/pour-genius/pour-genius.component').then(
				(m) => m.PourGeniusComponent,
			),
		canActivate: [AuthGuard],
	},
	{
		path: 'mahjong',
		loadComponent: () =>
			import('./mini-apps/mahjong/mahjong.component').then(
				(m) => m.MahjongComponent,
			),
		canActivate: [AuthGuard],
	},
	{
		path: 'snakes-ladders',
		loadComponent: () =>
			import('./mini-apps/snakes/snakes-ladders.component').then(
				(m) => m.SnakesLaddersComponent,
			),
		canActivate: [AuthGuard],
	},
	{
		path: 'card-games',
		loadComponent: () =>
			import('./mini-apps/card-games/card-games.component').then(
				(m) => m.CardGamesComponent,
			),
		canActivate: [AuthGuard],
	},
	{
		path: 'werewolf',
		loadComponent: () =>
			import('./mini-apps/werewolf/werewolf.component').then((m) => m.WerewolfComponent),
		canActivate: [AuthGuard],
	},
	// Public invitation; private roles require the player's room credential.
	{
		path: 'ww-room/:code',
		loadComponent: () =>
			import('./mini-apps/werewolf/werewolf-room.component').then((m) => m.WerewolfRoomComponent),
	},
	// PUBLIC (no AuthGuard): a friend opens a shared Phone-a-Friend / Challenge
	// link with no account — the spec's growth loop (§9).
	{
		path: 'pg-help/:code',
		data: { pgMode: 'help' },
		loadComponent: () =>
			import('./mini-apps/pour-genius/pg-public-play.component').then(
				(m) => m.PgPublicPlayComponent,
			),
	},
	{
		path: 'pg-play/:code',
		data: { pgMode: 'play' },
		loadComponent: () =>
			import('./mini-apps/pour-genius/pg-public-play.component').then(
				(m) => m.PgPublicPlayComponent,
			),
	},
	// PUBLIC (no AuthGuard): a friend opens a WordTadka Phone-a-Friend link and
	// solves the shared level to bail out the requester. Reuses WordTadkaComponent
	// in "help mode" (it reads the :code route param).
	{
		path: 'wt-help/:code',
		loadComponent: () =>
			import('./mini-apps/word-tadka/word-tadka.component').then(
				(m) => m.WordTadkaComponent,
			),
	},
	// PUBLIC (no AuthGuard): a friend opens a Mahjong "Race a Friend" link and
	// joins the live race — no account needed (per-device playerId).
	{
		path: 'mj-race/:code',
		loadComponent: () =>
			import('./mini-apps/mahjong/mahjong-race.component').then(
				(m) => m.MahjongRaceComponent,
			),
	},
	// PUBLIC (no AuthGuard): a friend opens a Word Search "Race a Friend" link
	// and joins the live race — no account needed (per-device playerId).
	{
		path: 'ws-race/:code',
		loadComponent: () =>
			import('./mini-apps/word-search/word-search-race.component').then(
				(m) => m.WordSearchRaceComponent,
			),
	},
	// PUBLIC (no AuthGuard): a friend opens a Snakes & Ladders room link and
	// claims a seat in the live match — no account needed (per-device playerId).
	{
		path: 'sl-room/:code',
		loadComponent: () =>
			import('./mini-apps/snakes/snakes-room.component').then(
				(m) => m.SnakesRoomComponent,
			),
	},
	{
		path: 'cg-room/:code',
		loadComponent: () =>
			import('./mini-apps/card-games/card-games-room.component').then(
				(m) => m.CardGamesRoomComponent,
			),
	},
	{
		path: 'profile',
		loadComponent: () =>
			import('./profile/profile.component').then((m) => m.ProfileComponent),
		canActivate: [AuthGuard],
	},
	{
		path: 'change-password',
		loadComponent: () =>
			import('./change-password/change-password.component').then(
				(m) => m.ChangePasswordComponent,
			),
		canActivate: [AuthGuard],
	},
	{
		path: '',
		component: AppShellComponent,
		canActivate: [AuthGuard],
		children: [
			{
				path: 'expenses',
				loadChildren: () =>
					import('./mini-apps/expense-app/expense-app.routes').then(
						(m) => m.expenseAppRoutes,
					),
				resolve: [LoadExpenseTrackerData],
			},
			{
				path: 'habit-tracker',
				loadChildren: () =>
					import('./mini-apps/habit-tracker/habit-tracker.routes').then(
						(m) => m.habitTrackerRoutes,
					),
			},
		],
	},
];
